const sections = [
  { label: "它是什么", href: "#intro" },
  { label: "题材细分", href: "#genres" },
  { label: "分级尺度", href: "#rating" },
  { label: "代表作品", href: "#works" },
  { label: "版本差异", href: "#uncut" },
  { label: "人性母题", href: "#nature" },
  { label: "导演与流派", href: "#directors" },
  { label: "观影指引", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

const keywords = [
  "欧美伦理电影在线",
  "欧美伦理电影未删减",
  "欧美伦理电影禁忌",
  "欧美伦理电影人性",
  "欧美伦理电影尺度",
  "欧美伦理电影大尺度",
];

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-primary-800 text-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-accent-300">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold">欧美伦理电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/75 max-w-sm">
              一个围绕欧美伦理电影的中文内容专题：从题材细分、分级尺度到代表作品与人性母题，帮你在点击播放之前先想清楚自己在看什么。
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-accent-300">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {sections.map((s) => (
                <li key={s.href}>
                  <a
                    href={s.href}
                    className="font-label text-sm text-background-50/80 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-accent-300">相关主题</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {keywords.map((k) => (
                <span
                  key={k}
                  className="px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/15 font-label text-xs text-background-50/80"
                >
                  {k}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="font-label text-xs text-background-50/65">
            © 2026 欧美伦理电影 · 中文内容专题
          </p>
          <p className="font-label text-xs text-background-50/65 max-w-xl">
            本站内容为影片主题讨论与影评参考，不提供任何影片播放与下载。请通过正规渠道观看，并遵守当地分级与法律法规。
          </p>
        </div>
      </div>
    </footer>
  );
}